<template>
  <div class="software-detail">
    <div class="header-box">
      <layoutHeader :default-bg="'rgba(0,0,0,0.4)'"/>
    </div>
    <div class="content">
      <div class="tab">
        <div class="list">
          <template v-for="(item, index) in list">
          <div class="item" :key="index" :class="index === tabIndex?'active':''" @click="onChangeType(index)">{{ item.softwareSystemText }}</div>
          </template>
        </div>
      </div>

      <div class="detail">
        <div class="main-container">

          <div class="top">
            <div class="left">
              <div class="info">
                <div class="cover">
                  <el-image :src="detail.softwareIcon"></el-image>
                </div>
                <div class="name-con">
                  <div class="name">{{ detail.softwareName }}</div>
                  <div class="version">{{ detail.softwareVersion }}</div>
                </div>
              </div>
              <div class="download">
                <el-tooltip placement="top" v-if="detail.softwareSystem <= 1">
                  <div slot="content">
                    <div class="software-detail-qrcode">
                      <el-image
                          :src="'https://wenhairu.com/static/api/qr/?size=150&text='+detail.softwareUrl"></el-image>
                      <div class="tips">扫码下载</div>
                    </div>
                  </div>
                  <div class="btn">
                    <el-image :src="require('@/assets/slices/icon_apple.png')" class="icon"
                              v-if="detail.softwareSystem == 1"></el-image>
                    <el-image :src="require('@/assets/slices/icon_Android.png')" class="icon"
                              v-else-if="detail.softwareSystem == 0"></el-image>
                    {{ detail.softwareSystemText }}下载
                  </div>
                </el-tooltip>
                <div class="btn" v-else @click="toDownload(detail.softwareUrl)">
                  {{ detail.softwareSystemText }}下载
                </div>
              </div>
            </div>
            <div class="right">
              <div class="bg-container" :class="detail.softwareSystem <= 1 ? 'mobile':''">
                <img src="@/assets/slices/icon_iphone.png" alt="" class="bg-img" v-if="detail.softwareSystem <= 1">
                <img src="@/assets/slices/icon_macbook.png" alt="" class="bg-img" v-else>
                <div class="swiper-container swiper" id="homeSwiper">
                  <div class="swiper-wrapper">
                    <template v-for="(item, index) in detail.softwareImage">
                      <div class="swiper-slide" :key="index">
                        <el-image :src="item" fit="contain"></el-image>
                      </div>
                    </template>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>

              </div>
            </div>
          </div>

          <div class="spec">
            <div class="item">
              <div class="name">大小</div>
              <div class="info">{{ detail.softwareSize }}</div>
            </div>
            <div class="item">
              <div class="name">下载</div>
              <div class="info">{{ detail.downloadTimes ? detail.downloadTimes : 0 }}次</div>
            </div>
            <div class="item">
              <div class="name">语言</div>
              <div class="info">{{ detail.softwareLang }}</div>
            </div>
            <div class="item">
              <div class="name">类别</div>
              <div class="info">{{ detail.softwareType }}</div>
            </div>
            <div class="item">
              <div class="name">更新日期</div>
              <div class="info">{{ detail.updateTime }}</div>
            </div>
          </div>

          <div class="desc">
            <div class="left">
              <div class="name">软件介绍</div>
              <div class="name-en">Software introduction</div>
            </div>
            <div class="right">
              <div class="info">{{ detail.softwareIntroduction }}</div>
            </div>
          </div>

          <div class="log">
            <div class="left">
              <div class="name">更新日志</div>
              <div class="name-en">update record</div>
            </div>
            <div class="right">
              <div class="title">{{ detail.softwareVersion }}版本更新介绍</div>
              <div class="info">{{ detail.softwareLog }}</div>
            </div>
          </div>

          <div class="history">
            <div class="name">历史版本</div>
            <div class="name-en">historic version</div>
            <div class="table">
              <div class="list table-header">
                <div class="item">
                  <el-image :src="require('@/assets/slices/icon_version.png')"></el-image>
                  版本
                </div>
                <div class="item">
                  <el-image :src="require('@/assets/slices/icon_size.png')"></el-image>
                  大小
                </div>
                <div class="item">
                  <el-image :src="require('@/assets/slices/icon_date.png')"></el-image>
                  更新时间
                </div>
                <div class=" operator">操作</div>
              </div>
              <template v-for="(item, index) in detail.softwareHistoryList"
                        v-if="detail.softwareHistoryList.length > 0">
                <div class="list">
                  <div class="item">{{ item.softwareVersion }}</div>
                  <div class="item">{{ item.softwareSize }}</div>
                  <div class="item">{{ item.updateTime }}</div>
                  <div class=" operator">
                    <el-image :src="require('@/assets/slices/icon_download.png')"
                              @click="toDownload(item.softwareUrl)"></el-image>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import Model from '@/model/software'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import Utils from "@/utils/util";

export default {
  components: {
    layoutHeader,
  },
  name: 'layout',
  data() {
    return {
      detail: {},
      tabIndex: 0,
      list: [],
      tableData: []
    }
  },
  created() {
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    async getDetail() {
      const res = await Model.getSoftwareInfoList(this.$route.query.name, this.$route.query.system)
      res.data.forEach(item => {

        item.updateTime = Utils.timestampToDate(item.updateTime)
        item.softwareImage = item.softwareImage.split(',')
        item.softwareSystemText = Model.softwareSystemList[item.softwareSystem]
        item.softwareType = Model.softwareTypeList[item.softwareType]
        item.softwareSize = Utils.formatterSize(item.softwareSize)
        item.softwareHistoryList.forEach(sonItem => {
          sonItem.softwareSize = Utils.formatterSize(sonItem.softwareSize)
          sonItem.updateTime = Utils.timestampToDate(sonItem.updateTime)
        })
      })
      this.list = res.data
      this.detail = res.data[this.tabIndex]
      this.initSwiper()
      console.log('res', res)
    },
    initSwiper() {
      setTimeout(() => {
        new Swiper('#homeSwiper', {
          spaceBetween: 30,
          loop: true,
          autoplay: true,
          observeParents: true,   //修改swiper自己或子元素时，自动初始化swiper
          observer: true,
          pagination: {
            el: '.swiper-pagination',
          }
        })
      }, 300)
    },
    async toDownload(url) {
      await Model.softwareTimes(this.$route.query.name)
      window.open(url)
    },
    onChangeType(index) {
      this.tabIndex = index
      this.detail = this.list[index]
    }
  }
}
</script>

<style lang="scss">


.swiper-pagination-bullet-active {
  background: #EB6100;
}

.software-detail-qrcode {
  width: 160px;
  height: 168px;
  box-sizing: border-box;
  padding: 18px 0 13px;
  background: #8d8d8d;
  border-radius: 6px;
  text-align: center;
  margin-bottom: 14px;

  .el-image {
    width: 110px;
    height: 110px;
    border: 1px solid #fff;
  }

  .tips {
    margin-top: 10px;
  }
}

</style>
<style lang="scss" scoped>


.software-detail {
  //background: #181818;
  background: url('https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/product_bg.png') no-repeat center center;
  background-size: cover;
  padding-top: 80px;
  color: #fff;


  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }


  .content {
    .tab {
      height: 60px;
      margin: 60px 0;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #fff;
      justify-content: center;

      .list {
        display: flex;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #fff;
      }

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 124px;
        height: 52px;
        border-radius: 4px;
        cursor: pointer;

        &:first-child {
          border-right: 1px solid #fff;
          border-radius: 4px 0 0 4px;
        }

        &.active {
          background: #EB6100;
        }
      }

    }

    .detail {
      padding: 0 40px 60px;
      display: flex;
      justify-content: center;

      .main-container {
        border-radius: 24px;
        border: 4px solid rgba(255, 255, 255, 0.3);

        .top {
          padding: 125px 76px 72px 150px;
          border-radius: 20px 20px 0 0;
          display: flex;
          background: #1b2c5f url('https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661408485644503071.png') no-repeat center center;
          background-size: cover;

          .left {
            flex: 1;

            .info {
              display: flex;
              margin-bottom: 38px;

              .cover {
                width: 126px;
                height: 126px;
                border-radius: 17px;
                margin-right: 60px;
                border: 1px solid #fff;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .name-con {

                .name {
                  font-size: 30px;
                  font-weight: 500;
                  margin-bottom: 20px;
                }

                .version {
                  font-size: 16px;
                }
              }
            }


            .btn {
              background: #EB6100;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              height: 40px;
              padding: 9px 30px;
              border-radius: 4px;
              font-weight: 500;
              margin-top: 220px;
              cursor: pointer;

              .el-image {
                margin-right: 10px;
                width: 21px;
                height: 21px;
              }
            }
          }

          .right {
            width: 593px;
            text-align: center;
            display: flex;
            justify-content: center;

            .bg-container {
              width: 593px;
              height: 351px;
              padding: 11px 0;
              position: relative;

              .bg-img {
                position: absolute;
                width: 100%;
                top: 0;
                left: 0;
              }

              .swiper {
                width: 479px;
                height: 315px;
                padding-bottom: 100px;

                .el-image {
                  width: 479px;
                  height: 315px;

                  img {
                    width: 479px;
                    height: auto;

                  }
                }
              }
            }

            .bg-container.mobile {
              width: 263px;
              height: 474px;
              position: relative;

              .bg-img {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 10;
              }

              .swiper {
                width: 190px;
                height: 400px;
                padding-bottom: 50px;
                margin-left: 32px;
                margin-top: 10px;

                .el-image {
                  width: 190px;
                  height: 400px;

                  img {
                    width: 190px;
                    height: auto;
                  }
                }
              }
            }

          }
        }

        .spec {
          background: rgba(86, 86, 86, 0.5);
          display: flex;
          padding: 28px 0 34px;

          .item {
            flex: 1;
            text-align: center;
            border-right: 1px solid rgba(255, 255, 255, 0.1);

            &:last-child {
              border: none;
            }

            .name {
              font-size: 24px;
              color: rgba(255, 255, 255, 0.6);
              margin-bottom: 20px;
            }

            .info {
              font-size: 24px;
              color: #fff;
              font-weight: 500;
            }
          }
        }

        .desc, .log {
          display: flex;
          box-sizing: border-box;
          padding: 52px 75px 150px 75px;

          .left {
            text-align: center;
            padding: 0 75px;

            .name {
              font-size: 53px;
              font-weight: 500;
              line-height: 62px;
            }

            .name-en {
              font-size: 16px;
              font-weight: 500;
            }
          }

          .right {
            flex: 1;
            padding: 100px 75px 0;
            width: 716px;

            .title {
              font-size: 24px;
              font-weight: 500;
              margin-bottom: 24px;
            }

            .info {
              line-height: 2rem;
              text-align: left;
              font-size: 16px;
            }
          }
        }

        .log {
          .left {
            .name {

            }

            .name-en {
            }
          }

          .right {
            .title {
            }

            .info {
            }
          }
        }

        .history {
          padding: 52px 169px 97px 150px;

          .name {
            font-size: 53px;
            font-weight: 500;
            line-height: 62px;
          }

          .name-en {
            font-size: 16px;
            font-weight: 500;
          }

          .table {
            margin-top: 38px;
            background: rgba(143, 143, 143, 0.2);
            border-radius: 4px;
            padding: 0 54px;

            .list {
              display: flex;
              align-items: center;
              height: 82px;
              border-top: 1px solid rgba(255, 255, 255, 0.3);

              &:first-child {
                border: none;
              }


              .operator {
                width: 70px;
                text-align: center;
                cursor: pointer;
              }

              .item {
                flex: 1;
                color: #fff;
              }
            }

            .table-header .item, .table-header .operator {
              display: flex;
              align-items: center;
              color: rgba(255, 255, 255, 0.4);

              .el-image {
                margin-right: 5px;
              }
            }

            .table-header .operator {
              justify-content: center;
            }

          }

        }

      }
    }

  }


}
</style>
